module.exports = __webpack_public_path__ + "static/media/297373.69e9c67b.png";